export default "__VITE_ASSET__D1XHDKk6__"